"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _CustomSelect = require("./CustomSelect");

var _NativeSelect = require("./NativeSelect");

var _excluded = ["native"];

var Select = function Select(_ref) {
  var _ref$native = _ref["native"],
      _native = _ref$native === void 0 ? false : _ref$native,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  return _native ? /*#__PURE__*/_react["default"].createElement(_NativeSelect.NativeSelect, props) : /*#__PURE__*/_react["default"].createElement(_CustomSelect.CustomSelect, props);
};

exports.Select = Select;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTZWxlY3QiLCJuYXRpdmUiLCJwcm9wcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9TZWxlY3QudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IEN1c3RvbVNlbGVjdCB9IGZyb20gJy4vQ3VzdG9tU2VsZWN0JztcbmltcG9ydCB7IE5hdGl2ZVNlbGVjdCB9IGZyb20gJy4vTmF0aXZlU2VsZWN0JztcblxudHlwZSBOYXRpdmVQcm9wcyA9IFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBOYXRpdmVTZWxlY3Q+O1xudHlwZSBDdXN0b21Qcm9wcyA9IFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBDdXN0b21TZWxlY3Q+O1xudHlwZSBQcm9wcyA9IE5hdGl2ZVByb3BzIHwgQ3VzdG9tUHJvcHM7XG5cbmV4cG9ydCBjb25zdCBTZWxlY3Q6IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBuYXRpdmUgPSBmYWxzZSxcbiAgLi4ucHJvcHNcbn0pID0+XG4gIG5hdGl2ZSA/IChcbiAgICA8TmF0aXZlU2VsZWN0IHsuLi4ocHJvcHMgYXMgTmF0aXZlUHJvcHMpfSAvPlxuICApIDogKFxuICAgIDxDdXN0b21TZWxlY3Qgey4uLihwcm9wcyBhcyBDdXN0b21Qcm9wcyl9IC8+XG4gICk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7Ozs7QUFNTyxJQUFNQSxNQUFnRCxHQUFHLFNBQW5EQSxNQUFtRDtFQUFBO0VBQUEsSUFDOURDLE9BRDhELDRCQUNyRCxLQURxRDtFQUFBLElBRTNEQyxLQUYyRDs7RUFBQSxPQUk5REQsT0FBTSxnQkFDSixnQ0FBQywwQkFBRCxFQUFtQkMsS0FBbkIsQ0FESSxnQkFHSixnQ0FBQywwQkFBRCxFQUFtQkEsS0FBbkIsQ0FQNEQ7QUFBQSxDQUF6RCJ9